import React, { Component } from 'react';
import YouTube from 'react-youtube';
import iconPlayGradient from '../../sass/icons/icon-play-gradient.svg';
import Button from '../Commons/Button';
import './Video.scss';

class Video extends Component {
  constructor() {
    super()
    this.state = {
      showVideo: false,
      height: 0
    }
  }

  componendDidMount () {
    window.addEventListener('resize', function () {
      this.calculateSize()  
    })
  }

  calculateSize() {
    const height = this.videoContainer.clientHeight;
    const width = this.videoContainer.clientWidth;
    this.setState({
      height,
      width
    });
  }

  handleClick() {
    this.calculateSize()
    this.setState({
      showVideo: !this.state.showVideo
    });
  }

  render() {
    const opts = {
      height: this.state.height,
      width: this.state.width,
      playerVars: {
        autoplay: 1,
        rel: 0
      }
    }
    if(this.state.showVideo) {
      return (
        <div
          style={this.props.style}>
          <div style={{ height: this.state.height }}>
            <YouTube
              videoId={this.props.videoId}
              opts={opts} />
          </div>
        </div>
      )
    } else {
      return (
        <div className="video"
          style={this.props.style}
          ref={ (videoContainer) => this.videoContainer = videoContainer}>
          <Button name={`play ${this.props.position || 'middle'}`} icon={iconPlayGradient}  onClick={() => this.handleClick()} />
          {
            this.props.text &&
            <span className="text">{this.props.text}</span>
          }
          <img src={this.props.background} alt=""/>
        </div>
      )
    }

  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Header/Video.js